module.exports = __webpack_public_path__ + "static/img/jiaotong-9.43a0702.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-9.png
// module id = wbIC
// module chunks = 1